import { render, staticRenderFns } from "./koufen.vue?vue&type=template&id=eca0baba&scoped=true&"
import script from "./koufen.vue?vue&type=script&lang=js&"
export * from "./koufen.vue?vue&type=script&lang=js&"
import style0 from "./koufen.vue?vue&type=style&index=0&id=eca0baba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca0baba",
  null
  
)

export default component.exports